import React from "react";
import { TileLayer } from "react-leaflet";

// Fond de carte clair/moderne façon CARTO Positron — sans clé API, contrairement à CARTO
// (basemaps.cartocdn.com) qui a commencé à exiger une clé même en usage gratuit léger (filigrane
// "API KEY REQUIRED" en pleine carte, régression côté CARTO courant 2026-09). Esri sert son fond
// "Light Gray Canvas" en deux calques superposés (fond gris/teintes de terrain, puis routes/
// labels en PNG transparent) plutôt qu'une seule image déjà composée comme CARTO — d'où les deux
// <TileLayer> plutôt qu'un seul. Gratuit et sans clé pour un usage de ce volume (services ArcGIS
// Online historiques, cf. le catalogue leaflet-providers "Esri.WorldGrayCanvas").
export default function ModernMapTiles({ maxZoom = 19 }: { maxZoom?: number }) {
  // maxNativeZoom=16 : au-delà, Esri ne sert plus de vraies tuiles (tuile "Map data not yet
  // available" à partir du niveau 17) — Leaflet reste alors sur les tuiles du niveau 16 et les
  // agrandit lui-même, plutôt que d'afficher ce message d'erreur en pleine carte.
  return (
    <>
      <TileLayer
        url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
        maxZoom={maxZoom}
        maxNativeZoom={16}
        attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ'
      />
      <TileLayer
        url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}"
        maxZoom={maxZoom}
        maxNativeZoom={16}
      />
    </>
  );
}
